import { createAsyncActionConstants } from 'utilities/util';

export const TYPES = {
    FETCH_MDM_CODE: createAsyncActionConstants('FETCH_MDM_CODE'),
    FETCH_PRINTER: createAsyncActionConstants('FETCH_PRINTER'),
    FETCH_OUTPUT: createAsyncActionConstants('FETCH_OUTPUT'),
    FETCH_REASON_CODES_OUTPUT: createAsyncActionConstants('FETCH_REASON_CODES_OUTPUT')
}